/** @jsx jsx */
import * as React from "react";
import { css, jsx } from "@emotion/core";
import { connect, Dispatch } from "react-redux";
import { IAppState } from "../models/IAppState";
import { interventionsContainerStyles } from "../styles/Interventions/interventionsContainer";
import { SugarJournalSummary } from "../components/SugarJournal/SugarJournalSummary";
import { SugarJournalTable } from "../components/SugarJournal/SugarJournalTable";

import { ISugarJournalResponse } from "../models/ISugarJournalResponse";
import { InterventionsActions } from "../actions/IntervantionsActions";
import { ISugarJournalRequest } from "../models/ISugarJournalRequest";
import { AppConstants } from "../utils/AppConstants";
import { Card } from "../components/common/Card";
import { IPatientDetail } from "@curefit/care-common";



interface IIntervantionsProps {
    patientProfile: IPatientDetail
    showHeader: boolean
}

interface IIntervantionsState {
    sugarJournalData: ISugarJournalResponse[];
}


interface IIntervantionsPropsFromDispatch {
    getSugarJournalData(params: ISugarJournalRequest): Promise<ISugarJournalResponse[]>
}

class SugarJournalComponent extends React.Component<IIntervantionsProps & IIntervantionsPropsFromDispatch, IIntervantionsState>{
    constructor(props: IIntervantionsProps & IIntervantionsPropsFromDispatch) {
        super(props);
        this.state = {
            sugarJournalData: []
        };
        this.fetchMetricServiceData = this.fetchMetricServiceData.bind(this);
    }

    componentDidMount() {
        this.fetchMetricServiceData();
    }

    private fetchMetricServiceData(): void {
        const params: ISugarJournalRequest = {
            userId: this.props.patientProfile.curefitUserId,
            subUserId: this.props.patientProfile.id,
            latest: true,
            metricId: AppConstants.GLUCOSE_CHRONIC_CARE_METRIC_ID,
            tenant: AppConstants.SUGAR_FIT_TENANT
        };

        this.props.getSugarJournalData(params)
            .then(sugarJournalData => {
                this.setState({ sugarJournalData });
                console.log(sugarJournalData);
            }).catch(console.error)
    }

    render() {
        const { sugarJournalData } = this.state;
        const { showHeader } = this.props;
        return (<div>
            {showHeader !== false && <Card>
                <div css={interventionsContainerStyles.header}>Sugar Journal</div>
            </Card>}
            <SugarJournalSummary data={sugarJournalData} />
            <SugarJournalTable data={sugarJournalData} />
        </div>)
    }
}

const mapStateToProps = (state: IAppState, ownProps: any): IIntervantionsProps => {
    return {
        patientProfile: state.patientCompleteInfo.profile,
        showHeader: ownProps.showHeader
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
    return {
        getSugarJournalData: (params: ISugarJournalRequest) => InterventionsActions.getSugarJournalData(params)
    };
}

export const SugarJournalContainer = connect(mapStateToProps, mapDispatchToProps)(SugarJournalComponent);